import { render } from "./CustomerOfferTable.vue?vue&type=template&id=d384181c&scoped=true&ts=true&lang=pug"
import script from "./CustomerOfferTable.vue?vue&type=script&lang=ts"
export * from "./CustomerOfferTable.vue?vue&type=script&lang=ts"

import "./CustomerOfferTable.vue?vue&type=style&index=0&id=d384181c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d384181c"]])

export default __exports__